import {useEffect} from 'react';
import useStore from './use-store';

const useCustomers = (query) => {
    const {store} = useStore();

    useEffect(() => {
        store.customerStore.loadCustomers(query);
    }, []);

    return {customers: store.customerStore};
};

export default useCustomers;
